export interface AuthorizationPermission {
    realm: string;
    applicationInstance: string;
    organisationId: number;
    permissions: string[];
}
